import loadable from '@loadable/component';
const Giftcard = loadable(() => import('./init'));
export default Giftcard;
